/* ALTON — product page: variant selection, price/availability updates,
   URL sync, media swap, quantity, lightbox gallery. */
(function () {
  'use strict';

  function initProductForm(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var optionCount = data.options.length;

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addButton = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var inventoryEl = root.querySelector('[data-inventory]');
    var selected = (root.dataset.selectedOptions || '').split('||');

    function currentVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    /* Option values in the order the buttons render, so "nearest" means
       nearest on screen rather than nearest in the data. */
    function optionValues(index) {
      var seen = [];
      root.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (btn) {
        var v = btn.dataset.optionValue;
        if (seen.indexOf(v) < 0) seen.push(v);
      });
      if (!seen.length) {
        variants.forEach(function (v) {
          if (seen.indexOf(v.options[index]) < 0) seen.push(v.options[index]);
        });
      }
      return seen;
    }

    /* ------------------------------------------------------------------
       AUTO-JUMP

       Variant matrices are rarely complete. On Clifton Regulars Tee, Red is
       made in XXS through 3XL while Moss Cottage is only S through 2XL. So
       picking Red / 3XL and switching to Moss Cottage lands on a combination
       that was never manufactured — the button reads "unavailable", which
       looks like a bug and reads like sold out.

       When the option just changed leaves the OTHER options pointing at a
       combination that does not exist, those others move to the nearest
       value that does. The option the shopper actually touched is never
       overridden — changing their choice out from under them would be worse
       than the dead end.

       "Nearest" is by position in the rendered list, so 3XL falls back to
       2XL rather than jumping to XS: size lists run small to large, and the
       adjacent size is the likeliest fit.
    ------------------------------------------------------------------ */
    function repair(changedIndex) {
      if (currentVariant()) return;

      for (var i = 0; i < optionCount; i++) {
        if (i === changedIndex) continue;

        var values = optionValues(i);
        var currentPos = values.indexOf(selected[i]);
        var best = null;
        var bestDistance = Infinity;

        for (var k = 0; k < values.length; k++) {
          var candidate = values[k];
          if (candidate === selected[i]) continue;

          var trial = selected.slice();
          trial[i] = candidate;

          var exists = variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (opt, n) { return opt === trial[n]; });
          });
          if (!exists) continue;

          var distance = currentPos < 0 ? k : Math.abs(k - currentPos);
          if (distance < bestDistance) { bestDistance = distance; best = candidate; }
        }

        if (best !== null) {
          selected[i] = best;
          if (currentVariant()) return;
        }
      }
    }

    function updateLabels() {
      root.querySelectorAll('[data-option-label]').forEach(function (el) {
        var i = parseInt(el.dataset.optionLabel, 10);
        el.textContent = selected[i] || '';
      });
    }

    function updateUI() {
      var variant = currentVariant();

      root.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var i = parseInt(btn.dataset.optionIndex, 10);
        var val = btn.dataset.optionValue;
        btn.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');

        /* Struck through only if the value exists in NO available variant at
           all. A value that merely clashes with the current selection stays
           live, because clicking it now repairs the rest of the selection
           rather than dead-ending. */
        var existsAnywhere = variants.some(function (v) {
          return v.options[i] === val && v.available;
        });
        btn.classList.toggle('unavailable', !existsAnywhere);
      });
      updateLabels();

      if (!variant) {
        if (addButton) {
          addButton.setAttribute('disabled', '');
          addButton.textContent = addButton.dataset.unavailableText;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('disabled');
          addButton.textContent = addButton.dataset.addText + (variant.price_formatted ? ' \u2014 ' + variant.price_formatted : '');
        } else {
          addButton.setAttribute('disabled', '');
          addButton.textContent = addButton.dataset.soldOutText;
        }
      }
      if (inventoryEl) {
        var qty = variant.inventory_quantity;
        if (variant.inventory_managed && variant.available && qty > 0 && qty <= 5) {
          inventoryEl.textContent = inventoryEl.dataset.lowText.replace('[qty]', qty);
          inventoryEl.hidden = false;
        } else {
          inventoryEl.hidden = true;
        }
      }

      if (variant.featured_media_id) {
        var mediaEl = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (mediaEl && mediaEl.scrollIntoView && window.innerWidth >= 1080) {
          mediaEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      if (window.history && window.history.replaceState && root.dataset.updateUrl === 'true') {
        window.history.replaceState({}, '', data.url + '?variant=' + variant.id);
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (btn) {
        e.preventDefault();
        var changed = parseInt(btn.dataset.optionIndex, 10);
        selected[changed] = btn.dataset.optionValue;
        repair(changed);
        updateUI();
        return;
      }
      var qtyBtn = e.target.closest('[data-qty-step]');
      if (qtyBtn) {
        e.preventDefault();
        var input = root.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.qtyStep, 10));
      }
    });

    updateUI();
  }

  /* ---------- Lightbox ---------- */
  function initLightbox() {
    var lightbox = document.getElementById('ProductLightbox');
    if (!lightbox || lightbox.dataset.initialized) return;
    lightbox.dataset.initialized = 'true';

    var img = lightbox.querySelector('img');
    var sources = [];
    var index = 0;

    function collect() {
      sources = Array.prototype.map.call(document.querySelectorAll('[data-lightbox-open]'), function (el) {
        return el.dataset.lightboxSrc;
      }).filter(Boolean);
    }
    function show() {
      if (img && sources[index]) { img.src = sources[index]; }
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (opener) {
        e.preventDefault();
        collect();
        index = sources.indexOf(opener.dataset.lightboxSrc);
        if (index < 0) index = 0;
        show();
        if (window.altonOverlay) window.altonOverlay.open(lightbox, { lockScroll: true, trigger: opener });
        return;
      }
      if (!lightbox.classList.contains('open')) return;
      if (e.target.closest('[data-lb-prev]')) { e.preventDefault(); index = (index - 1 + sources.length) % sources.length; show(); }
      else if (e.target.closest('[data-lb-next]')) { e.preventDefault(); index = (index + 1) % sources.length; show(); }
      else if (e.target.closest('[data-lb-close]') || e.target === lightbox) { e.preventDefault(); window.altonOverlay.close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'ArrowLeft') { index = (index - 1 + sources.length) % sources.length; show(); }
      if (e.key === 'ArrowRight') { index = (index + 1) % sources.length; show(); }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-root]').forEach(initProductForm);
    initLightbox();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
